// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cursor__cursor___rVeSj {
    --cursor-color: var(--color-bg-normal);
    --size: var(--space-xs);

    display: inline-flex;

    width: var(--size);
    min-width: var(--size);
    height: var(--size);
    min-height: var(--size);

    background-color: transparent;
    border-radius: 50%;

    &.Cursor__badge____zbiX {
        --cursor-color: var(--color-bg-link);

        width: 0.2rem;
        min-width: 0.2rem;
        height: var(--size-text-xs);
        border-radius: 0.1rem;
    }

    &.Cursor__active___Cj3ks {
        background-color: var(--cursor-color);
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Cursor/Cursor.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;IACtC,uBAAuB;;IAEvB,oBAAoB;;IAEpB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;IAEvB,6BAA6B;IAC7B,kBAAkB;;IAElB;QACI,oCAAoC;;QAEpC,aAAa;QACb,iBAAiB;QACjB,2BAA2B;QAC3B,qBAAqB;IACzB;;IAEA;QACI,qCAAqC;IACzC;AACJ","sourcesContent":[".cursor {\n    --cursor-color: var(--color-bg-normal);\n    --size: var(--space-xs);\n\n    display: inline-flex;\n\n    width: var(--size);\n    min-width: var(--size);\n    height: var(--size);\n    min-height: var(--size);\n\n    background-color: transparent;\n    border-radius: 50%;\n\n    &.badge {\n        --cursor-color: var(--color-bg-link);\n\n        width: 0.2rem;\n        min-width: 0.2rem;\n        height: var(--size-text-xs);\n        border-radius: 0.1rem;\n    }\n\n    &.active {\n        background-color: var(--cursor-color);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cursor": `Cursor__cursor___rVeSj`,
	"badge": `Cursor__badge____zbiX`,
	"active": `Cursor__active___Cj3ks`
};
export default ___CSS_LOADER_EXPORT___;
